module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/isana_lippenpflege_social_media_spot_small.jpg";